import React, { useState } from 'react';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { UiKit } from 'components';
import Plan from './Plan';
import { useSubscription, useBilling } from 'utils/hooks';
import { PLAN_MODE, PLAN_SLUGS } from 'dictionary';

export default function ShopifySubscriptionModal() {
  const [paymentMode, setPaymentMode] = useState(PLAN_MODE.YEARLY);
  const {
    source,
    isQuotaExhausted,
    showSubscriptionModal,
    onToggleSubscriptionModal
  } = useSubscription();
  const {
    plans,
    processingPlan,
    isNotifiedForEnterprise,
    onSubscribe
  } = useBilling({
    loadOnMount: isQuotaExhausted && source === 'SHOPIFY',
    payload: { redirect_url: '/' }
  });

  const upgradablePlansList = plans.reduce((acc, data, index) => {
    const id = _get(data, 'id', index);
    const slug = _get(data, 'slug', '');
    const isEnterprisePlan = slug === PLAN_SLUGS.ENTERPRISE;
    const planPrice = _get(data, `prices.${paymentMode}.price`, 0);

    const onPlanSelect = () => {
      onSubscribe({
        slug,
        payload: {
          plan_slug: slug,
          payment_mode: paymentMode
        }
      });
    };

    if (planPrice > 0 || isEnterprisePlan) {
      acc.push(
        <Plan
          key={id}
          data={data}
          term={paymentMode}
          processingPlan={processingPlan}
          isNotifiedForEnterprise={isNotifiedForEnterprise}
          onSubscribe={onPlanSelect}
        />
      );
    }

    return acc;
  }, []);

  const onToggleTerm = () => {
    setPaymentMode(
      paymentMode === PLAN_MODE.MONTHLY ? PLAN_MODE.YEARLY : PLAN_MODE.MONTHLY
    );
  };

  return (
    <UiKit.Modal
      centered
      isOpen={showSubscriptionModal}
      onClose={onToggleSubscriptionModal}
    >
      <UiKit.Modal.Header
        title="Oh No! You've reached the end of your return limit"
        hideCrossBtn
      />
      <UiKit.Modal.Body>
        <p className={styles.description}>
          Please upgrade your service tier to continue processing returns.
        </p>
        <div className={styles.termToggle}>
          <UiKit.Toggle
            isActive={paymentMode === 'yearly'}
            onChange={onToggleTerm}
          />
          <span>Show Annual Plans</span>
        </div>
        <h6 className={styles.optionsHeading}>Upgrade Options:</h6>
        <UiKit.Grid gap="20" className={styles.plansList}>
          {upgradablePlansList}
        </UiKit.Grid>
        <strong className={styles.note}>
          Note: No new service requests will be created until the end of this
          calendar month until a plan is subscribed.
        </strong>
      </UiKit.Modal.Body>
    </UiKit.Modal>
  );
}
